<template>
  <ancestryline-modal title="dataTable.reports.protocol-control.checklist-status" id="modal-checklist-pending-certificates" :close="true" @close="close" :loading="loading">
    <p v-if="pendingPersonsList.length === 0">{{$t('dataTable.reports.protocol-control.checklist-status-empty')}}</p>
    <div class="p-mb-12" v-for="(person, index) in pendingPersonsList" :key="index">
      <strong>{{person.name}}</strong>
      <ul>
        <li v-for="(type, typeIndex) in person.pendingTypes" :key="typeIndex">{{type}}</li>
      </ul>
    </div>

    <template #footer>
      <Button :label="$t('btn.close')" class="p-button-secondary" @click.prevent="close"/>
    </template>
  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";
import ChecklistStatusBusiness from "@/business/ChecklistStatusBusiness";

export default {
  name: "ModalChecklistPendingCertificates",

  props: {
    protocolId: {type: String, default: null},
    pendingPersons: {type: Array, default: null},
  },

  data(){
    return {
      loading: this.pendingPersons === null,
      pendingPersonsList: this.pendingPersons || [],
    }
  },

  async mounted(){
    if(this.pendingPersons === null){
      this.pendingPersonsList = await ChecklistStatusBusiness.getPendingPersonsByProtocolId(this.protocolId);
      this.loading = false;
    }
  },

  methods: {

    close(){
      DialogService.closeModal();
    },

  }

}
</script>

<style scoped>

</style>
